import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const usePathName = () => {
  const { pathname, search } = useLocation();

  const currentPath = useMemo(() => {
    const { pathname } = location;
    const currentPathName = pathname.split('/')[1];
    return currentPathName ? `/${currentPathName}` : pathname;
  }, [pathname, search]);

  return { currentPath };
};
